import { OverlayTrigger, Tooltip } from "react-bootstrap-v5";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const InfoTooltipIcon = ({  id, 
                            infoText, 
                            placement = "top", 
                            className = "" 
                        }) => {

    if (!infoText) return null;

    return (
        <OverlayTrigger placement={placement} overlay={<Tooltip id={`tooltip-${id}`}>{infoText}</Tooltip>}>
            <span 
                className={`text-info ms-2 ${className}`} 
                style={{ cursor: "pointer", display: "inline-block" }}
            >
                <FontAwesomeIcon icon={faInfoCircle} />
            </span>
        </OverlayTrigger>
    );
};

export default InfoTooltipIcon;